const TIMEZONES = {
  PACIFIC: "America/Los_Angeles",
  EASTERN: "America/New_York",
  CENTRAL: "America/Chicago",
  MOUNTAIN: "America/Denver",
};

const FULL_ZONE_NAMES = {
  EST: "Eastern Standard Time",
  EDT: "Eastern Daylight Time",
  CST: "Central Standard Time",
  CDT: "Central Daylight Time",
  MST: "Mountain Standard Time",
  MDT: "Mountain Daylight Time",
  PST: "Pacific Standard Time",
  PDT: "Pacific Daylight Time",
} as const;

type TimezoneAbbreviation = keyof typeof FULL_ZONE_NAMES;
type IanaTimezone = (typeof TIMEZONES)[keyof typeof TIMEZONES];

const TIMEZONE_ABBREVIATION_TO_IANA: Record<TimezoneAbbreviation, IanaTimezone> = {
  PST: TIMEZONES.PACIFIC,
  PDT: TIMEZONES.PACIFIC,
  EST: TIMEZONES.EASTERN,
  EDT: TIMEZONES.EASTERN,
  CST: TIMEZONES.CENTRAL,
  CDT: TIMEZONES.CENTRAL,
  MST: TIMEZONES.MOUNTAIN,
  MDT: TIMEZONES.MOUNTAIN,
};

const DEFAULT_TIMEZONE = TIMEZONES.PACIFIC;

export { TIMEZONES, DEFAULT_TIMEZONE, FULL_ZONE_NAMES, TIMEZONE_ABBREVIATION_TO_IANA };
